import { getApiKey } from 'utils/environment';

interface IUseApiKey {
  key: string;
  defaultValue?: string;
}

/** @deprecated just use getApiKey - TODO REMOVE THIS */
export const useApiKey = ({ key, defaultValue = '' }: IUseApiKey) => {
  return getApiKey({ key, defaultValue });
};
